import { render, staticRenderFns } from "./DynamicNews.vue?vue&type=template&id=5ed608ba&scoped=true"
import script from "./DynamicNews.vue?vue&type=script&lang=js"
export * from "./DynamicNews.vue?vue&type=script&lang=js"
import style0 from "./DynamicNews.vue?vue&type=style&index=0&id=5ed608ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed608ba",
  null
  
)

export default component.exports